import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Gen3Features } from '../components/Gen3Features';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { ShopByCategory } from '../components/ShopByCategory';
import { TeamBuyersSection } from '../components/TeamBuyersSection';
import { SupportSection } from '../components/SupportSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 flex flex-col" data-id="element-479">
      <Header data-id="element-480" />

      <main className="flex-grow" data-id="element-481">
        <Hero data-id="element-482" />
        <Gen3Features data-id="element-483" />
        <ShopByCategory data-id="element-484" />
        <FeaturedProducts data-id="element-485" />
        <TeamBuyersSection data-id="element-486" />
        <SupportSection data-id="element-487" />
      </main>

      <Footer data-id="element-488" />
    </div>;
}